export const MAX_ARGS_SIZE = 50 * 1024; // 50 kb (100 kb is the max payload. Leaving half of space for other data in the payload.)